import React from 'react';
import {Link} from 'react-router';
import {DiamondFill, Lock, People} from '@goproblems/ui/icons';
import {CollectionPrivacy, type SingleProblem} from '@types';
import {useTranslation} from 'react-i18next';

type CollectionsListProps = Pick<SingleProblem, 'collections' | 'isFavorited'>;

const CollectionList: React.FC<CollectionsListProps> = ({
    collections,
    isFavorited: favourite,
}) => {
    const {t} = useTranslation();

    return (
        <>
            {favourite && (
                <li>
                    <Link className="link" to="/dashboard/favorites">
                        {t('common.favorite')}
                    </Link>
                </li>
            )}
            {collections.map(collection => (
                <li key={collection.id}>
                    {collection.core && (
                        <span
                            className="mx-1 text-warning inline-flex align-items-center"
                            title={t('problem_collections.core_collection')}
                            aria-label={t('problem_collections.core_collection')}>
                            <DiamondFill size={10} />
                        </span>
                    )}
                    {collection.privacy === CollectionPrivacy.PRIVATE && (
                        <span
                            className="mx-1 inline-flex align-items-center"
                            style={{position: 'relative', top: '2px'}}
                            title={t('problem_collections.private_collection')}
                            aria-label={t('problem_collections.private_collection')}>
                            <Lock />
                        </span>
                    )}
                    {collection.privacy === CollectionPrivacy.FRIENDS && (
                        <span
                            className="mx-1 inline-flex align-items-center"
                            style={{position: 'relative', top: '2px'}}
                            title={t('problem_collections.friends_collection')}
                            aria-label={t('problem_collections.friends_collection')}>
                            <People />
                        </span>
                    )}
                    <Link
                        className="link"
                        to={`/collections/${collection.id}`}>
                        {collection.name}
                    </Link>{' '}
                </li>
            ))}
        </>
    );
};

export default CollectionList;
